import { render, staticRenderFns } from "./BoxplotChart.vue?vue&type=template&id=1fa57834&"
import script from "./BoxplotChart.vue?vue&type=script&lang=js&"
export * from "./BoxplotChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports